<template >
  <div>
    <!--  入荷種類選択画面 -->
    <t-card>
      <div
        :style="{
          height: basicHeight + 'px',
          'padding-top': '10px',
          'padding-bottom': '10px',
        }"
      >
        <t-form :model="selectReceiveForm" label-position="right">
          <t-row class="col_common_center">
            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
              >&nbsp;</t-col
            >
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHTEEN'))"
            >
              <!-- 運送からの入荷 -->
              <t-radio
                v-model="selectReceiveForm.jpReceType"
                :label="1"
                style="line-height: 3; width: 40%"
                >{{ $t("resource.JP_RECEIVE.TRANSPORT_RECEIVE") }}</t-radio
              >
              <!-- 日本・本社工場の入荷 -->
              <t-radio
                v-model="selectReceiveForm.jpReceType"
                :label="2"
                style="line-height: 3; width: 40%"
                >{{ $t("resource.JP_RECEIVE.JP_OFFICE_RECEIVE") }}</t-radio
              >
            </t-col>

            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="right"
            >
              <!-- 確定 -->
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="ConfirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
              >&nbsp;</t-col
            >
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import {
  ShowJpReceDLEditDialog,
  ShowJpReceJPOfficeEditDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import { DIALOG_LINE_HEIGHT, NUM_ONE, NUM_TWO } from "@/utils/const";

import { ref } from "vue";
export default {
  data() {
    return {
      //検索条件
      selectReceiveForm: {
        jpReceType: "", // 仕入先
      },

      //入荷一覧情報
      jpRcvBasicForm: [],

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
  },
  mounted() {
    // 初期化
    this.init();
  },

  methods: {
    // 初期化
    init() {
      // 編集の場合
      if (!!this.isAdd) {
        // 新規の場合、チェックボックスは「運送からの入荷」が選択
        this.selectReceiveForm.jpReceType = ref(1);
      }
    },

    //确定ボタン
    ConfirmClick() {
      if (!!this.selectReceiveForm.jpReceType) {
        if (this.selectReceiveForm.jpReceType == NUM_ONE) {
          //日本入荷詳細画面（大連工場）
          ShowJpReceDLEditDialog(
            {
              isAdd: true,
            },
            t("resource.JP_RECEIVE.JP_RCV_DL_DETAIL_DIALOG"),
            this.Close
          );
        } else if (this.selectReceiveForm.jpReceType == NUM_TWO) {
          //日本入荷詳細画面（大連以外の工場）
          ShowJpReceJPOfficeEditDialog(
            {
              isAdd: true,
            },
            t("resource.JP_RECEIVE.JP_RCV_OTHER_DETAIL_DIALOG"),
            this.Close
          );
        }
        // this.$emit("ok");
      }
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
</style>
